// Size guide units: tables whose cells carry data-inch and data-cm switch between the two with one toggle.
// The size guide page holds plain data; the theme owns the control. The shopper's choice is remembered.
if (!customElements.get('size-units')) {
	class SizeUnits extends HTMLElement {
		connectedCallback() {
			this.querySelectorAll('table').forEach((table) => this.scrollable(table));
			this.values = this.querySelectorAll('[data-inch][data-cm]');
			if (!this.values.length || this.querySelector('.size-units--toggle')) return;
			const table = this.querySelector('table');
			const toggle = document.createElement('div');
			toggle.className = 'size-units--toggle';
			toggle.setAttribute('role', 'group');
			toggle.setAttribute('aria-label', this.dataset.label || '');
			this.buttons = ['inch', 'cm'].map((unit) => {
				const button = document.createElement('button');
				button.type = 'button';
				button.dataset.unit = unit;
				button.textContent = unit === 'inch' ? this.dataset.labelInch || 'in' : this.dataset.labelCm || 'cm';
				button.addEventListener('click', () => this.set(unit, true));
				toggle.appendChild(button);
				return button;
			});
			(table ? table.closest('.size-units--shadow') : this.firstElementChild).before(toggle);
			let saved = null;
			try {
				saved = localStorage.getItem('size-units');
			} catch (error) {}
			this.set(saved === 'inch' || saved === 'cm' ? saved : this.dataset.default || 'cm', false);
		}
		// The table scrolls sideways in its own box with an edge fade, so a wide chart never widens the popup or the page.
		// The box is a named, focusable region so keyboard users can scroll it too (Safari never focuses scroll boxes).
		scrollable(table) {
			if (table.parentElement.classList.contains('size-units--scroll')) return;
			const shadow = document.createElement('scroll-shadow');
			shadow.className = 'size-units--shadow';
			const box = document.createElement('div');
			box.className = 'size-units--scroll';
			box.tabIndex = 0;
			box.setAttribute('role', 'region');
			box.setAttribute('aria-label', this.tableName(table));
			table.before(shadow);
			box.appendChild(table);
			shadow.appendChild(box);
		}
		// The chart's own caption, else the heading written above it on the page, else the guide's name.
		tableName(table) {
			const caption = table.caption && table.caption.textContent.trim();
			if (caption) return caption;
			for (let node = table.previousElementSibling; node && node.tagName !== 'TABLE'; node = node.previousElementSibling) {
				if (/^H[1-6]$/.test(node.tagName) && node.textContent.trim()) return node.textContent.trim();
			}
			return this.dataset.label || '';
		}
		set(unit, remember) {
			this.values.forEach((value) => {
				value.textContent = value.dataset[unit];
			});
			this.buttons.forEach((button) => button.setAttribute('aria-pressed', button.dataset.unit === unit ? 'true' : 'false'));
			if (remember) {
				try {
					localStorage.setItem('size-units', unit);
				} catch (error) {}
			}
		}
	}
	customElements.define('size-units', SizeUnits);
}
